<template>
  <div class="visitor-card">
    <div class="left">
      <div class="visitor-card__title">{{ cardInfo.title }}</div>
      <div v-if="showMemo" class="visitor-card__memo">{{ cardInfo.memo }}</div>
      <div class="visitor-card__time">
        <span class="title">执行时间</span>
        <span class="value">{{ formatTime(cardInfo.executeTime) }}</span>
      </div>
      <div class="visitor-card__target">
        <span class="title">拜访目的</span>
        <span class="value">{{ cardInfo.communicateTarget }}</span>
      </div>
    </div>
    <div v-if="showRightBtn" class="right" @click="rela">关联</div>
  </div>
</template>

<script setup>
import dayjs from 'dayjs'

const props = defineProps({
  cardInfo: {
    type: Object,
    default: () => ({})
  },
  showRightBtn: {
    type: Boolean,
    default: false
  },
  showMemo: {
    type: Boolean,
    default: true
  }
})

const emits = defineEmits('rela')

function rela() {
  emits('rela', props.cardInfo)
}

function formatTime(timestamp) {
  const date = dayjs(timestamp * 1000)
  const today = dayjs().startOf('day')

  if (date.isSame(today, 'year')) {
    return date.format('MM 月 DD 日 HH:mm')
  } else {
    return date.format('YYYY 年 MM 月 DD 日 HH:mm')
  }
}
</script>

<style lang="less" scoped>
.visitor-card {
  border-radius: 8px;
  background-color: #fff;
  padding: 12px;
  border: 1px solid #e5e6eb;
  display: flex;
  align-items: center;
  overflow: hidden;
  .left {
    flex: 1;
    overflow: hidden;
  }
  .right {
    cursor: pointer;
    width: 40px;
    text-align: right;
    font-size: 14px;
    color: #248df5;
    cursor: pointer;
  }
  &__title {
    color: #323233;
    font-weight: 600;
    font-size: 14px;
    line-height: 20px;
    margin-bottom: 2px;
  }
  &__memo {
    font-size: 14px;
    color: #969799;
    line-height: 20px;
    margin-bottom: 8px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  &__time {
    margin-bottom: 4px;
  }
  &__time,
  &__target {
    line-height: 20px;
    font-size: 14px;
    color: #323233;
    .title {
      color: #969799;
      margin-right: 12px;
    }
  }
}
</style>
